import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import supabase from "../supabase";

export function ProtectedRoute({ children }) {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  if (session === undefined) return <p>Loading...</p>;
  if (!session) return <Navigate to="/" replace />;

  return children;
}
